import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@material-ui/styles";
// component, hooks
// store
// config,utils
import IntroBannerDefaultImg from "../../../../../images/home_explain_analytics/home_explain_analytics.png";

// style
const StyledBoxBg = styled(Box, {})(({ theme }) => ({}));

const StyledContainer = styled(
  Container,
  {}
)(({ theme }) => ({
  paddingX: "80px",
}));

const IntroBanner = ({
  direction,
  tag,
  bgColor,
  title,
  content,
  imgSrc,
  imgSrcSet,
}) => {
  // props

  // route,intl
  // store
  // local state
  // hooks

  const getCornerBoxProp = () => {
    const getBgImg = () => {
      switch (bgColor) {
        case "yellow":
          return "linear-gradient(to bottom, #fce262, #fbda37)";
        case "orange":
          return "linear-gradient(to top, #ffb629, #ffa20d)";
        case "blue":
          return "linear-gradient(to bottom, #3bbff0, #06a2e6)";
        default:
          return "linear-gradient(to bottom, #fce262, #fbda37)";
      }
    };
    if (direction === "left") {
      return {
        marginRight: "auto",
        backgroundImage: getBgImg(),
        borderTopRightRadius: "100px",
        borderBottomRightRadius: "100px",
      };
    }
    return {
      marginLeft: "auto",
      backgroundImage: getBgImg(),
      borderTopLeftRadius: "100px",
      borderBottomLeftRadius: "100px",
    };
  };

  const getContentGridDirection = () => {
    if (direction === "left") {
      return "row";
    }
    return "row-reverse";
  };

  return (
    <StyledBoxBg>
      <Box height="0px">
        {/* 背景 banner */}
        <Box
          style={{
            position: "relative",
            top: "46px",
            width: "calc(50% + 50px)",
            height: "200px",
            ...getCornerBoxProp(),
          }}
        />
      </Box>
      {/* 內文 */}
      <StyledContainer>
        <Grid
          container
          direction={getContentGridDirection()}
          justifyContent="space-between"
          alignItems="center"
          sx={{ zIndex: 50, position: "relative" }}
          rowSpacing={{ sx: 0, sm: 0, md: 30, lg: 40 }}
        >
          {/* 左邊 */}
          <Grid
            item
            justifyContent="center"
            alignItems="center"
            sx={{ width: "552px" }}
          >
            <Box>
              <img
                src={imgSrc}
                srcSet={imgSrcSet}
                alt="home carousel interaction"
                width={552}
                height={312}
              />
            </Box>
          </Grid>
          {/* 右邊 */}
          <Grid
            item
            container
            justifyContent="flex-start"
            alignItems="center"
            sx={{ width: "408px" }}
          >
            <Grid item>
              <Box mb={2}>
                <Typography variant="body1" color="primary">
                  {tag}
                </Typography>
              </Box>
              <Box mb={4}>
                <Typography variant="h4">{title}</Typography>
              </Box>
              <Box>
                <Typography variant="body1">{content}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </StyledContainer>
    </StyledBoxBg>
  );
};

IntroBanner.propTypes = {
  direction: PropTypes.oneOf(["left", "right"]),
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.any),
  ]),
  bgColor: PropTypes.oneOf(["yellow", "blue", "orange"]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  imgSrc: PropTypes.string,
  imgSrcSet: PropTypes.string,
};

IntroBanner.defaultProps = {
  direction: "left",
  tag: "",
  bgColor: "orange",
  title: "",
  content: "",
  imgSrc: "",
  imgSrcSet: "",
};

export default IntroBanner;
